<template>
	<div
		v-if="selectedCompanyId"
		class="app-sidebar-company-main"
	>
		<div
			v-for="category in filteredLinksByCategory"
			:key="`sidebar-category-${category.key}`"
			class="category-list mb-11 px-5"
		>
			<div
				class="category-title ao-p2-medium ao-text-secondary-color mb-4 px-2"
			>
				{{ category.title }}
			</div>

			<div
				v-for="link in category.links"
				:key="`category-link-${link.name}`"
				class="category-link"
			>
				<SidebarLink
					:to="{
						name: getTabRouteNameFromModuleRouteName(link.meta.defaultModule),
						params: { companyId: selectedCompanyId },
					}"
					:title="link.meta.titleTranslationKey ? $t(link.meta.titleTranslationKey) : link.meta.title"
					:icon="link.meta.iconKey"
					:loadedRouterLink="loadedRouterLink"
					:active="currentGroupName === link.name"
					:class="{'text-disabled': link.meta.hideInProduction}"
					@click="$emit('click:link')"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'

import { useUserStore } from '@/stores/userStore'
import { useCompanyStore } from '@/stores/companyStore'

import useRouts from '@/composables/useRouts'
import useNavigation from '@/composables/useNavigation'

import eventBus from '@/plugins/eventBus'

import SidebarLink from './SidebarLink.vue'

import { COMPANY_GROUPS } from '@/config/router/routerConfig'

defineEmits({
	'click:link': null,
})

const {
	router,
	// route,
	currentGroupName,
} = useRouts()

const userStore = useUserStore()
const { selectedCompanyId } = storeToRefs(userStore)

const companyStore = useCompanyStore()
const {
	availableRouteGroupsByCompanyLicense,
} = storeToRefs(companyStore)

const {
	categoryGroups,
} = useNavigation()

const filteredLinksByCategory = computed(() => {
	let categories = []
	for (const categoryKey in categoryGroups.value) {
		if (Object.hasOwnProperty.call(categoryGroups.value, categoryKey)) {
			const category = Object.assign({}, categoryGroups.value[categoryKey])
			category.links = COMPANY_GROUPS
				.filter((route) => (route.meta.categoryKey === category.value))
				.filter((route) => availableRouteGroupsByCompanyLicense.value.includes(route.name))
				.filter((link) => (isProductionMode.value ? !link.meta.hideInProduction : true))

			if (category.links.length > 0) {
				categories.push(category)
			}
		}
	}
	return categories
})

const isProductionMode = computed(() => {
	const productionModes = ['stage', 'prod']
	return productionModes.includes(import.meta.env.VITE_APP_ENV_MODE)
})

const getTabRouteNameFromModuleRouteName = (routeName) => {
	let module = router.getRoutes().find((item) => item.name === routeName)
	if (!module) {
		return routeName
	}
	return module.meta.defaultTabView ? module.meta.defaultTabView : module.name
}

const loadedRouterLink = ref(null)
const updateRouterLinkState = (payload) => {
	if (payload.status === 'start') {
		loadedRouterLink.value = payload.name
	} else {
		loadedRouterLink.value = null
	}
}

onMounted(() => {
	eventBus.$on(eventBus.eventNames.getNavigationRouterLinkLoading(), updateRouterLinkState)
})

onBeforeUnmount(() => {
	eventBus.$off(eventBus.eventNames.getNavigationRouterLinkLoading())
})
</script>

<style lang="scss">
// .app-sidebar-company-main {

// 	.left-sidebar-btn {
// 		padding: 0 8px;
// 	}

// }
</style>
